<div class="container-llwytho fade-in-once">
  <mat-progress-bar class="llwythwr-system bar-llwytho" color="accent" mode="query"></mat-progress-bar>
</div>
